<template>
    <BreadCrumb PageTitle="Liste des services" />
    <ListeOrganisation />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeOrganisation from "../../components/Organisation/ListeOrganisation.vue";

  export default defineComponent({
    name: "ListeOrganisationPage",
    components: {
      BreadCrumb,
      ListeOrganisation,
    },
  });
  </script>